export default "/react/logoSellerGPT-1424341f.png";